import { Image } from "antd";
import Imageconvocatoria from "../../../assets/landing/logo2026.png";
export const BannerPanelRegistroUsuarios = () => {
   return (
      <div className="container-background-jurados mb-3">
         <div className="subcontainer-background-participantes">
            <div className="container-fluid2">
               <div className="row ">
                  <div className="col-4 col-md-2 me-md-4 mt-5 mb-md-5">
                     <Image src={Imageconvocatoria} preview={false} />
                  </div>
                  <div className="col-12 col-md-9 mt-5 mb-5 d-flex align-items-center">
                     <div className="col-12">
                        <div
                           style={{ lineHeight: "normal" }}
                           className="d-flex font-family-Montserrat-Regular font-size-22px font-color-FFFFFF texto-sombras-general"
                        >
                           Formulario de registro
                        </div>
                        <div
                           style={{ lineHeight: "normal" }}
                           className="d-flex mt-3 font-family-Montserrat-Bold font-size-16px font-color-FFFFFF subtexto-sombras-general"
                        >
                           Convocatoria de fomento y estímulos para el arte y la cultura.
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

